import { Outlet } from "react-router-dom";
import MemberConsentGate from "@/components/MemberConsentGate";

export default function MembersLayout() {
  return (
    <MemberConsentGate>
      <Outlet />
    </MemberConsentGate>
  );
}
